import "../../styles/admin.css";
import DashboardBody from "./body";

export default function Dashboard(){

    return(
        <>
            <DashboardBody/>
        </>
    )
}
